import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-device-needs-to-be-linked',
  templateUrl: './device-needs-to-be-linked.component.html',
  styleUrls: ['./device-needs-to-be-linked.component.scss']
})
export class DeviceNeedsToBeLinkedComponent {
  constructor(private router: Router) {}

  returnToLogin() {
    this.router.navigate(['']);
  }
}
